// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"Spinner_loadingSpinner__O_jLV","rotate-forever":"Spinner_rotate-forever__8PVWy","bigSpinner":"Spinner_bigSpinner__DOTmb"};